export enum AccordionThemes {
  DEFAULT = 'default',
  DARK = 'dark',
}
